import React from "react";
import { useNavigate } from "react-router-dom";

const CRMWelcome = () => {
  const navigate = useNavigate();

  return (
    <div className="crm-section-card">
      <div className="crm-hero">
        <div className="crm-hero-text">
          <h2>Welcome to KostPadi CRM</h2>
          <p>
            Track leads, manage opportunities, monitor collections, and build a
            complete customer journey from first contact to payment.
          </p>

          <div className="crm-hero-actions">
            <button
              className="crm-primary-btn"
              onClick={() => navigate("/crm/dashboard")}
            >
              Open Dashboard
            </button>

            <button
              className="crm-secondary-btn"
              onClick={() => navigate("/crm/leads")}
            >
              Manage Leads
            </button>
          </div>
        </div>

        <div className="crm-hero-stats">
          <div className="crm-stat-box">
            <span className="crm-stat-label">Module</span>
            <strong className="crm-stat-value">CRM</strong>
          </div>

          <div className="crm-stat-box">
            <span className="crm-stat-label">Focus</span>
            <strong className="crm-stat-value">Sales + Customer</strong>
          </div>

          <div className="crm-stat-box">
            <span className="crm-stat-label">Flow</span>
            <strong className="crm-stat-value">Lead → Payment</strong>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CRMWelcome;
